// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const FireIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Fire/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.757 2.034a1 1 0 0 1 .638.519c.483.967.844 1.554 1.207 2.03.368.482.756.876 1.348 1.467A6.981 6.981 0 0 1 17 11 7 7 0 1 1 5.05 6.05a1 1 0 0 1 1.707.707c0 1.12.07 1.973.398 2.654.18.374.461.74.945 1.067.116-1.061.328-2.354.614-3.58.225-.966.506-1.93.84-2.734.166-.403.355-.785.569-1.116.209-.322.477-.65.822-.88a1 1 0 0 1 .812-.134Zm.364 13.087A3 3 0 0 1 7.001 13s.878.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .785 1.293 1.37 1.879a2.99 2.99 0 0 1 .88 2.121 2.99 2.99 0 0 1-.88 2.121Z",
  clipRule: "evenodd"
}));
export default FireIcon;